import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_359: DocMigration = {
  maxSchemaVersion: "0.0.359",
  description: "Ensure templateType property is set on content template instances",
  apply(json: any) {
    for (const instanceId in json.contentTemplateInstances) {
      const instance = json.contentTemplateInstances[instanceId];
      if (!instance.templateType) {
        const template = json.contentTemplates[instance.contentTemplateId];
        if (!template) {
          // delete instances with bad reference
          delete json.contentTemplateInstances[instanceId];
        } else {
          instance.templateType = template.templateType;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_359;
